import { types } from 'mobx-state-tree';
import { PointGeometry } from './point';
import { TAPlanGeometryAttributes } from './taGeometryAttributes';

const TAPoint = types
  .model('TAPoint', {
    point: types.maybe(PointGeometry)
  })
  .actions(self => ({
    update: graphic => {
      self.comment = graphic.attributes.comment;
      self.snapshotIndex = graphic.attributes.snapshotIndex;
      self.point = graphic.geometry.toJSON();
    }
  }));

export const TARegulationPoint = types.compose(TAPlanGeometryAttributes, TAPoint).named('TARegulationPoint');
